//create a function that checks if an element is overflowing and scrollable
export const isOverflowing = (element: Element): boolean => {
  return element.scrollHeight > element.clientHeight
}

//create a function that checks if parent is overflowing
export const scrollLockIsParentOverflowing = (element: Element): boolean => {
  //if parent doest have a parent element with data-scroll return false
  if (element.closest('[data-scroll]') === null) return false
  const parent = element.parentElement
  if (!parent) return false
  if (isOverflowing(parent)) return true
  return scrollLockIsParentOverflowing(parent)
}
